import type { RouteObject } from 'react-router';
import { OpportunitiesPage } from './OpportunitiesPage';

export const routes: RouteObject[] = [{ path: '/opportunities', element: <OpportunitiesPage /> }];
